import jamespot, { WidgetOrientedlinks } from 'jamespot-user-api';
import React from 'react';
import { DisplayInputComponentProps } from '../../types';
import type { FieldValues } from 'react-hook-form';
import { Model } from 'jamespot-front-business';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { useAppSelector } from '../../../redux/store';

export const OrientedLinkInput =
    (type = 'article', isRequired = true) =>
    // eslint-disable-next-line react/display-name
    <TFieldValues extends FieldValues>({ widget, ...props }: DisplayInputComponentProps<TFieldValues>) => {
        const InputAutocomplete = commonComponentsRegistry.getLazyComponent('InputAutocomplete');

        // {/* TODO multiple */}
        // const multiple = (widget as WidgetOrientedlinks).params["jcomplete-multiple"] === "1"
        const required = isRequired && props.mandatory;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const model = useAppSelector((state) => Model.selectors.selectById(state, type));
        const mainType = model?.mainType;

        if (!mainType) return <></>;

        const orientedLinksApis = {
            article: (inputValue: string) =>
                jamespot.article
                    .list({
                        type: (widget as WidgetOrientedlinks).params.supportedTypes?.[0] || '',
                        format: 'raw-view',
                        query: inputValue,
                    })
                    .then((res) => {
                        return res?.result?.data;
                    }),
            user: (inputValue: string) => jamespot.user.autocomplete(inputValue),
            spot: (inputValue: string) => jamespot.group.autocomplete(inputValue),
        };

        const autocomplete = (inputValue: string) =>
            Object.keys(orientedLinksApis).includes(mainType)
                ? orientedLinksApis[mainType as 'user' | 'article' | 'spot'](inputValue)
                : Promise.resolve([]);

        return (
            <InputAutocomplete
                label={props.label}
                placeholder={props.placeholder}
                description={props.description || ''}
                name={props.name}
                control={props.control}
                rules={{ required }}
                searchable
                // multiple={multiple}
                asyncPromise={autocomplete}
                margin={props.margin}
            />
        );
    };
